import * as React from 'react';
import { PassengerField } from '../../../../../Passenger/types';
import { Field } from '../../../../../Passenger/components/Field/Field';
import { FieldsGroupType } from '../utils';
import LoyaltyGroup from './LoyaltyGroup/LoyaltyGroup';
import ChangeGroup from './ChangeGroup/ChangeGroup';
import SubsidiesGroup from './SubsidiesGroup/SubsidiesGroup';
import { DocTypes, TravellerProfileFragment, AviaPassengerType, TravellerFieldEnum } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
import { useRenderers } from '../../../../../renderProps';
import Disabilities from '../../Disabilities/Disabilities';

export interface Props {
	fields: PassengerField[];
	passengerId: number;
	groupType: FieldsGroupType;
	passengerType: AviaPassengerType;
	selectedProfileId?: string;
	passengerDocType?: DocTypes;
	disabled?: boolean;
	isAuthorized?: boolean;
	isChangeFiles?: boolean;
	onTravellerSelect?: (values: TravellerProfileFragment, type?: TravellerFieldEnum, value?: string) => void;
	autofocus?: boolean;
	onSignUpLoyaltyProgram?: () => void;
	onSwap?: () => void;
	onToggleChangeFiles?: (expanded: boolean) => void;
	groupIcon?: React.ReactNode;
	docExpiryDateField?: PassengerField;
	birthDateField?: PassengerField;
}

const Group: React.FC<Props> = props => {
	if (props.groupType === FieldsGroupType.Changes) {
		return <ChangeGroup {...props} />;
	} else if (props.groupType === FieldsGroupType.Loyalty) {
		return <LoyaltyGroup {...props} />;
	} else if (props.groupType === FieldsGroupType.Subsidies) {
		return <SubsidiesGroup {...props} />;
	} else if (props.groupType === FieldsGroupType.Other) {
		return <Disabilities {...props} />;
	}

	const theme = useTheme('PassengerForm').Group;
	const { PassengerFormField: PassengerFormFieldOverride = Field } = useRenderers();

	return (
		<div
			className={cn(theme.container, {
				[theme.identity]: props.groupType === FieldsGroupType.Identity,
				[theme.documents]: props.groupType === FieldsGroupType.Documents,
				[theme.accompanying]: props.groupType === FieldsGroupType.Accompanying,
				[theme.contacts]: props.groupType === FieldsGroupType.Contacts,
				[theme.withIcons]: !!props.groupIcon
			})}
		>
			{props.groupIcon && <div className={theme.icon}>{props.groupIcon}</div>}

			{props.fields.map((field, index) => {
				return (
					<PassengerFormFieldOverride
						key={`${field.name}_${index}`}
						disabled={field.readonly || props.disabled}
						field={field}
						birthDateField={props.birthDateField}
						passengerId={props.passengerId}
						onTravellerSelect={props.onTravellerSelect}
						selectedProfileId={props.selectedProfileId}
						passengerType={props.passengerType}
						passengerDocType={props.passengerDocType}
						className={cn({
							[theme.field_sex]: field.type === TravellerFieldEnum.Gender,
							[theme.field_birthdate]: field.type === TravellerFieldEnum.BirthDate,
							[theme.field_middleName]: field.type === TravellerFieldEnum.MiddleName
						})}
						loadTravellers={props.isAuthorized}
						autofocus={props.autofocus && index === 0}
						onSwap={props.onSwap}
						docExpiryDateField={props.docExpiryDateField}
					/>
				);
			})}
		</div>
	);
};

export default Group;
